export enum StudiesPreferences {
  SHOW_FLOWCHART_PROCEDURE_RUN_DESIGN = 'SHOW_FLOWCHART_PROCEDURE_RUN_DESIGN',
}
